import {
  Document,
  Font,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from '@react-pdf/renderer'
import { toKana } from 'wanakana'

import { Gender, GenerateJapaneseCv } from '@/_gql/graphql'

import { dateFormat } from '@/lib/formatter'

interface TemplateCvJapanProps {
  dataPayload?: GenerateJapaneseCv
}

const splitText = (text: string, chunkSize = 500) => {
  const chunks = []
  for (let i = 0; i < text.length; i += chunkSize) {
    chunks.push(text.substring(i, i + chunkSize))
  }
  return chunks
}
export default function TemplateCvJapan({ dataPayload }: TemplateCvJapanProps) {
  const name_in_japanese = dataPayload?.name_in_japanese
  const user_personal_info = dataPayload?.user_personal_info
  const address_in_japanese = dataPayload?.address_in_japanese
  const summary_in_japanese = dataPayload?.summary_in_japanese
  const user_experience = dataPayload?.user_experience
  const user_education = dataPayload?.user_education

  const summary = dataPayload?.cv_summary
  const summaryChunks = summary ? splitText(summary) : ''

  const phone_number = dataPayload?.phone_number
  const email = dataPayload?.email

  const filledExperience =
    user_experience &&
    user_experience.concat(Array(10 - user_experience.length).fill(null))
  const filledEducation =
    user_education &&
    user_education.concat(Array(4 - user_education.length).fill(null))

  Font.register({
    family: 'NotoSansJP',
    fonts: [
      { src: '/font/notosans/NotoSansJP-Regular.ttf', fontWeight: 'normal' },
      { src: '/font/notosans/NotoSansJP-Medium.ttf', fontWeight: 'medium' },
      { src: '/font/notosans/NotoSansJP-SemiBold.ttf', fontWeight: 'semibold' },
      { src: '/font/notosans/NotoSansJP-Bold.ttf', fontWeight: 'bold' },
    ],
  })
  const styles = StyleSheet.create({
    page: {
      fontFamily: 'NotoSansJP',
      fontSize: '12px',
    },
    headerContainer: {
      display: 'flex',
      flexDirection: 'row',
      paddingLeft: '30px',
      paddingRight: '30px',
      paddingTop: '30px',
      gap: '10px',
    },
    headerLeft: {
      width: '80%',
    },
    headerRight: {
      display: 'flex',
    },
    containerImage: {
      width: '100px',
      height: '150px',
      border: '1px solid #000',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '6px',
      textAlign: 'center',
      marginTop: '14px',
      objectFit: 'cover',
    },
    imageProfile: {
      width: '100px',
      height: '150px',
      objectFit: 'cover',
    },
    headerTitle: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    tablePersonal: {
      // @ts-ignore
      display: 'table',
      width: 'auto',
      marginTop: '10px',
    },
    tablePersonalRow: {
      flexDirection: 'row',
      borderStyle: 'solid',
    },
    tablePersonalCol: {
      width: '100%',
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '20px',
    },
    tablePersonalColValue: {
      width: '65%',
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
    },
    labelPersonalCol: {
      width: '22%',
    },
    valueForm: {
      marginLeft: '20px',
      fontSize: '16px',
    },
    tableBirthCol: {
      width: '70%',
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
      display: 'flex',
      gap: '20px',
      flexDirection: 'row',
      alignItems: 'center',
    },
    valueBirthOf: {
      fontSize: '12px',
    },
    valueBirth: {
      fontSize: '16px',
    },
    tableBirthColValue: {
      width: '30%',
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
      display: 'flex',
      gap: '20px',
      flexDirection: 'row',
      alignItems: 'center',
    },
    fontSmall: {
      fontSize: '8px',
    },
    tableEmail: {
      paddingLeft: '30px',
      paddingRight: '30px',
      // @ts-ignore
      display: 'table',
      width: 'auto',
    },
    tableColLabelLeft: {
      width: '60%',
      borderStyle: 'solid',
      borderWidth: 1,
      flexWrap: 'wrap',
      display: 'flex',
      padding: '6px',
    },
    tableColLabelRight: {
      width: '40%',
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
    },
    tableColValueLeft: {
      width: '60%',
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
      height: '60px',
      flexWrap: 'wrap',
      display: 'flex',
    },

    tableColValueTextLeft: {
      width: '60%',
      height: '60px',
      flexWrap: 'wrap',
      display: 'flex',
      maxWidth: '100px',
    },
    tableColValueRight: {
      width: '40%',
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
      height: '60px',
    },
    tableExperience: {
      paddingLeft: '30px',
      paddingRight: '30px',
      // @ts-ignore
      display: 'table',
      width: 'auto',
      marginTop: '20px',
    },
    tableExperienceRow: {
      flexDirection: 'row',
      borderStyle: 'solid',
      height: '32px',
    },
    tableExperienceYear: {
      width: '20%',
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
    },
    tableExperiencePeriode: {
      width: '10%',
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
    },
    tableExperienceDescription: {
      width: '70%',
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
      display: 'flex',
      flexWrap: 'wrap',
    },
    tableHeaderExperienceYear: {
      width: '20%',
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
      textAlign: 'center',
    },
    tableHeaderExperiencePeriode: {
      width: '10%',
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
      textAlign: 'center',
    },
    tableHeaderExperienceDescription: {
      width: '70%',
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
      textAlign: 'center',
    },
    summaryDescription: {
      paddingLeft: '30px',
      paddingRight: '30px',
      marginTop: '20px',
    },
    summaryLabel: {
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
      height: '60px',
      minHeight: '60px',
    },
    summaryValue: {
      borderStyle: 'solid',
      borderWidth: 1,
      padding: '6px',
      minHeight: '100px',
    },
  })

  const getJapaneseDate = () => {
    return new Intl.DateTimeFormat('ja-JP', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(new Date())
  }

  const formatToJapaneseDate = (dateString: string) => {
    if (!dateString) return ''

    // Parse and format date
    const formattedDate = dateFormat(new Date(dateString), 'yyyy年MM月')

    // Convert numbers to Japanese (optional, not necessary for 年 and 月)
    return toKana(formattedDate)
  }

  const formatJapaneseDOB = (dob: any) => {
    if (!dob) return ''

    // Format date in Japanese style
    const formattedDate = dateFormat(new Date(dob), 'yyyy年MM月dd日生')

    // Calculate age
    const birthYear = new Date(dob).getFullYear()
    const currentYear = new Date().getFullYear()
    const age = currentYear - birthYear

    return `${formattedDate} （満 ${age}歳）`
  }

  const splitJapaneseText = (text: any, length = 40) => {
    if (!text) return ''

    // Use regex to split every 5 characters
    return text.match(new RegExp(`.{1,${length}}`, 'g')).join('\n')
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headerContainer}>
          <View style={styles.headerLeft}>
            <View style={styles.headerTitle}>
              <View>
                <Text>履 歴 書</Text>
              </View>
              <View>
                <Text>{getJapaneseDate()}</Text>
              </View>
            </View>
            <View>
              <View style={styles.tablePersonal}>
                <View style={styles.tablePersonalRow}>
                  <View style={styles.tablePersonalCol}>
                    <View style={styles.labelPersonalCol}>
                      <Text>フルネーム</Text>
                      <Text>Fullname</Text>
                    </View>
                    <View>
                      {' '}
                      <Text style={styles.valueForm}>
                        {user_personal_info?.name}
                      </Text>
                    </View>
                  </View>
                </View>
                <View style={styles.tablePersonalRow}>
                  <View style={styles.tablePersonalCol}>
                    <View style={styles.labelPersonalCol}>
                      <Text>フルネーム（カナ）</Text>
                      <Text>Fullname(kana)</Text>
                    </View>
                    <View>
                      {' '}
                      <Text style={styles.valueForm}>{name_in_japanese}</Text>
                    </View>
                  </View>
                </View>
                <View style={styles.tablePersonalRow}>
                  <View style={styles.tableBirthCol}>
                    <View style={styles.labelBirthCol}>
                      <Text>年 月 日生 （満 歳）</Text>
                      <Text style={styles.fontSmall}>Date of Birth</Text>
                    </View>
                    <View>
                      {' '}
                      <Text style={styles.valueBirthOf}>
                        {user_personal_info?.birthdate
                          ? formatJapaneseDOB(user_personal_info?.birthdate)
                          : ''}
                      </Text>
                    </View>
                  </View>
                  <View style={styles.tableBirthColValue}>
                    <View>
                      <Text>※性別</Text>
                      <Text>Gender</Text>
                    </View>
                    <View>
                      <Text style={styles.valueBirth}>
                        {user_personal_info?.gender == Gender.Men ? '男' : '女'}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View style={styles.headerRight}>
            <View style={styles.containerImage}>
              {/* <Text>
                                写真をはる位置<br />
                                写真をはる必要が <br />
                                ある場合<br />
                                1．縦  36～40mm<br />
                                横  24～30mm<br />
                                2.本人単身胸から上<br />
                                3.裏面のりづけ<br />
                            </Text> */}
              <Image
                style={styles.imageProfile}
                src={`${user_personal_info?.photo}?not-from-cache-please`}
              />
            </View>
          </View>
        </View>
        <View style={styles.tableEmail}>
          <View style={styles.tablePersonalRow}>
            <View style={styles.tableColLabelLeft}>
              <Text>住所 (Address)</Text>
            </View>
            <View style={styles.tableColLabelRight}>
              <Text>電子メール (Email)</Text>
            </View>
          </View>
          <View style={styles.tablePersonalRow}>
            <View style={styles.tableColValueLeft}>
              <Text>{user_personal_info?.address}</Text>
            </View>
            <View style={styles.tableColValueRight}>
              <Text>{email}</Text>
            </View>
          </View>
          <View style={styles.tablePersonalRow}>
            <View style={styles.tableColLabelLeft}>
              <Text>住所のカナ表記 (Address in kana)</Text>
            </View>
            <View style={styles.tableColLabelRight}>
              <Text>電話番号 (Phone Number)</Text>
            </View>
          </View>
          <View style={styles.tablePersonalRow}>
            <View style={styles.tableColValueLeft}>
              {splitJapaneseText(address_in_japanese)
                .split('\n')
                .map((line: any, index: any) => (
                  <Text key={index} style={styles.tableColValueTextLeft}>
                    {line}
                  </Text>
                ))}
              {/* <Text style={styles.tableColValueTextLeft}>{splitJapaneseText(address_in_japanese) ?? ''}</Text> */}
              {/* <Text style={styles.tableColValueTextLeft}>{address_in_japanese ? addBreaksToText(address_in_japanese, 5) : ''}</Text> */}
            </View>
            <View style={styles.tableColValueRight}>
              <Text>{phone_number}</Text>
            </View>
          </View>
        </View>
        <View style={styles.tableExperience}>
          <View style={styles.tableExperienceRow}>
            <View style={styles.tableHeaderExperienceYear}>
              <Text>年 </Text>
            </View>
            <View style={styles.tableHeaderExperiencePeriode}>
              <Text>月 </Text>
            </View>
            <View style={styles.tableHeaderExperienceDescription}>
              <Text>職歴 (Work History)</Text>
            </View>
          </View>
          {filledExperience?.map((experience, index) => (
            <View style={styles.tableExperienceRow}>
              <View style={styles.tableExperienceYear}>
                <Text>
                  {experience?.start_date
                    ? formatToJapaneseDate(experience?.start_date)
                    : ''}
                </Text>
              </View>
              <View style={styles.tableExperiencePeriode}>
                <Text>
                  {experience?.start_date
                    ? getPeriodeYear(experience.start_date, experience.end_date)
                    : ''}
                </Text>
              </View>
              <View style={styles.tableExperienceDescription}>
                <Text>
                  {experience
                    ? `${experience?.company_name} ${toKana(experience?.title)}`
                    : ''}
                </Text>
              </View>
            </View>
          ))}
        </View>
      </Page>
      <Page size="A4" style={styles.page}>
        <View style={styles.tableExperience}>
          <View style={styles.tableExperienceRow}>
            <View style={styles.tableHeaderExperienceYear}>
              <Text>年 </Text>
            </View>
            <View style={styles.tableHeaderExperiencePeriode}>
              <Text>月</Text>
            </View>
            <View style={styles.tableHeaderExperienceDescription}>
              <Text>教育的 (Education History)</Text>
            </View>
          </View>
          {/* <View style={styles.tableExperienceRow}>
                        <View style={styles.tableExperienceYear}>
                            <Text>2023</Text>
                        </View>
                        <View style={styles.tableExperiencePeriode}>
                            <Text>2025</Text>
                        </View>
                        <View style={styles.tableExperienceDescription}>
                            <Text>PT Indobit - Frontend Developer</Text>
                        </View>
                    </View> */}
          {filledEducation?.map((education, index) => (
            <View style={styles.tableExperienceRow}>
              <View style={styles.tableExperienceYear}>
                <Text>
                  {/* {education?.start_date ? formatDate(education?.start_date, 'yyyy') : ''} */}
                  {education?.start_date
                    ? formatToJapaneseDate(education?.start_date)
                    : ''}
                </Text>
              </View>
              <View style={styles.tableExperiencePeriode}>
                <Text>
                  {education?.start_date
                    ? getPeriodeYear(
                        education.start_date,
                        education.graduation_date
                      )
                    : ''}
                </Text>
              </View>
              <View style={styles.tableExperienceDescription}>
                <Text>
                  {/* {education ? ` ${education.level} -  ${education.major} - ${education.school}` : ''} */}
                  {education
                    ? `${education.school} ${toKana(education.major)}`
                    : ''}
                </Text>
              </View>
            </View>
          ))}
          {/* <View style={styles.tableExperienceRow}>
                        <View style={styles.tableExperienceYear}>
                            <Text></Text>
                        </View>
                        <View style={styles.tableExperiencePeriode}>
                            <Text></Text>
                        </View>
                        <View style={styles.tableExperienceDescription}>
                            <Text></Text>
                        </View>
                    </View>
                    <View style={styles.tableExperienceRow}>
                        <View style={styles.tableExperienceYear}>
                            <Text></Text>
                        </View>
                        <View style={styles.tableExperiencePeriode}>
                            <Text></Text>
                        </View>
                        <View style={styles.tableExperienceDescription}>
                            <Text></Text>
                        </View>
                    </View>
                    <View style={styles.tableExperienceRow}>
                        <View style={styles.tableExperienceYear}>
                            <Text></Text>
                        </View>
                        <View style={styles.tableExperiencePeriode}>
                            <Text></Text>
                        </View>
                        <View style={styles.tableExperienceDescription}>
                            <Text></Text>
                        </View>
                    </View>
                    <View style={styles.tableExperienceRow}>
                        <View style={styles.tableExperienceYear}>
                            <Text></Text>
                        </View>
                        <View style={styles.tableExperiencePeriode}>
                            <Text></Text>
                        </View>
                        <View style={styles.tableExperienceDescription}>
                            <Text></Text>
                        </View>
                    </View> */}
        </View>
        <View style={styles.tableExperience}>
          <View style={styles.tableExperienceRow}>
            <View style={styles.tableHeaderExperienceYear}>
              <Text>年</Text>
            </View>
            <View style={styles.tableHeaderExperiencePeriode}>
              <Text>月 </Text>
            </View>
            <View style={styles.tableHeaderExperienceDescription}>
              <Text>資 格 ・ 免 許 (Qualifications and licenses)</Text>
            </View>
          </View>
          {/* <View style={styles.tableExperienceRow}>
                        <View style={styles.tableExperienceYear}>
                            <Text>2023</Text>
                        </View>
                        <View style={styles.tableExperiencePeriode}>
                            <Text>2025</Text>
                        </View>
                        <View style={styles.tableExperienceDescription}>
                            <Text>PT Indobit - Frontend Developer</Text>
                        </View>
                    </View> */}
          <View style={styles.tableExperienceRow}>
            <View style={styles.tableExperienceYear}>
              <Text></Text>
            </View>
            <View style={styles.tableExperiencePeriode}>
              <Text></Text>
            </View>
            <View style={styles.tableExperienceDescription}>
              <Text></Text>
            </View>
          </View>
          <View style={styles.tableExperienceRow}>
            <View style={styles.tableExperienceYear}>
              <Text></Text>
            </View>
            <View style={styles.tableExperiencePeriode}>
              <Text></Text>
            </View>
            <View style={styles.tableExperienceDescription}>
              <Text></Text>
            </View>
          </View>
          <View style={styles.tableExperienceRow}>
            <View style={styles.tableExperienceYear}>
              <Text></Text>
            </View>
            <View style={styles.tableExperiencePeriode}>
              <Text></Text>
            </View>
            <View style={styles.tableExperienceDescription}>
              <Text></Text>
            </View>
          </View>
          <View style={styles.tableExperienceRow}>
            <View style={styles.tableExperienceYear}>
              <Text></Text>
            </View>
            <View style={styles.tableExperiencePeriode}>
              <Text></Text>
            </View>
            <View style={styles.tableExperienceDescription}>
              <Text></Text>
            </View>
          </View>
        </View>
        <View style={styles.summaryDescription}>
          <View style={styles.summaryLabel}>
            <Text>
              {' '}
              本人希望記入欄（特に給料・職種・勤務時間・勤務地・その他について希望などがあれば記入
            </Text>
            <Text style={styles.fontSmall}>
              {' '}
              Section for personal preferences (please write down any
              preferences you have regarding salary, job type, working hours,
              work location, etc.)
            </Text>
          </View>
          <View style={styles.summaryValue}>
            <Text>{summary_in_japanese}</Text>
          </View>
        </View>
        {summary && summary?.length < 500 ? (
          <>
            <View style={styles.summaryDescription}>
              <View style={styles.summaryLabel}>
                <Text>
                  {' '}
                  Section for personal preferences (please write down any
                  preferences you have regarding salary, job type, working
                  hours, work location, etc)
                </Text>
              </View>
              <View style={styles.summaryValue}>
                <Text>{summary}</Text>
              </View>
            </View>
          </>
        ) : (
          <></>
        )}
      </Page>
      {summary && summary.length >= 500 ? (
        <>
          <Page size="A4" style={styles.page}>
            <View style={styles.summaryDescription}>
              <View style={styles.summaryLabel}>
                <Text>
                  {' '}
                  Section for personal preferences (please write down any
                  preferences you have regarding salary, job type, working
                  hours, work location, etc)
                </Text>
              </View>
              <View style={styles.summaryValue}>
                <Text>{summary}</Text>
              </View>
            </View>
          </Page>
        </>
      ) : (
        <></>
      )}
      {/* {summaryChunks[1] && summaryChunks[1]?.length > 0 ? (
                <Page size="A4" style={styles.page}>
                    <View style={styles.summaryDescription}>
                        <View style={styles.summaryValue}><Text>{summaryChunks[1]}</Text></View>

                    </View>
                </Page>
            ) : (<></>)} */}
    </Document>
  )
}

function getPeriodeYear(start_date: string, end_date?: string | null) {
  if (start_date && start_date !== null) {
    const start = new Date(start_date)
    const end = end_date ? new Date(end_date) : new Date()

    if (end == null) {
      return 'Now'
    }

    const yearsDifference = end.getFullYear() - start.getFullYear()
    return yearsDifference < 10 ? `0${yearsDifference}` : `${yearsDifference}`
  }
}

function addBreaksToText(text: string, maxWords: number) {
  const words = text.split('')

  const result = []

  for (let i = 0; i < words.length; i++) {
    result.push(words[i])

    if ((i + 1) % maxWords === 0) {
      result.push('<br/>')
    }
  }

  return result.join(' ')
}
